// Main Screen
export const SELECTED_TAB = "SELECTED_TAB";
export const SELECTED_MODEL = "SELECTED_MODEL";
export const SET_SNACKBAR = "SET_SNACKBAR";

export const SET_CLOSE_MODEL = "SET_CLOSE_MODEL";
//Triple Screen Page
export const GET_REGIONST = "GET_REGIONST";
export const GET_REGIONST_SUCCESS = "GET_REGIONST_SUCCESS";
export const GET_REGIONST_FAILURE = "GET_REGIONST_FAILURE";
//  {/*Sales data*/}
export const GET_SALES_OFFICE = "GET_SALES_OFFICE";
export const GET_SALES_OFFICE_SUCCESS = "GET_SALES_OFFICE_SUCCESS";
export const GET_SALES_OFFICE_FAILURE = "GET_SALES_OFFICE_FAILURE";
//  {/*market data*/}
export const GET_MARKET = "GET_MARKET";
export const GET_MARKET_SUCCESS = "GET_MARKET_SUCCESS";
export const GET_MARKET_FAILURE = "GET_MARKET_FAILURE";  
// Pagination
export const SELECTED_MODEL_PAGE = "SELECTED_MODEL_PAGE";
export const SELECTED_DRAWING_PAGE = "SELECTED_DRAWING_PAGE";
export const SELECTED_VIEW_PAGE = "SELECTED_VIEW_PAGE";

export const GET_MODELS = "GET_MODELS";
export const GET_MODELS_SUCCESS = "GET_MODELS_SUCCESS";
export const GET_MODELS_FAILURE = "GET_MODELS_FAILURE";

export const CREATE_NEW_MODEL = "CREATE_NEW_MODEL";
export const CREATE_NEW_MODEL_SUCCESS = "CREATE_NEW_MODEL_SUCCESS";
export const CREATE_NEW_MODEL_FAILURE = "CREATE_NEW_MODEL_FAILURE";

export const UPDATE_MODEL = "UPDATE_MODEL";
export const UPDATE_MODEL_SUCCESS = "UPDATE_MODEL_SUCCESS";
export const UPDATE_MODEL_FAILURE = "UPDATE_MODEL_FAILURE";

export const DELETE_MODEL = "DELETE_MODEL";
export const DELETE_MODEL_SUCCESS = "DELETE_MODEL_SUCCESS";
export const DELETE_MODEL_FAILURE = "DELETE_MODEL_FAILURE";

export const SEARCH_VALUE_MODEL = "SEARCH_VALUE_MODEL";
export const SORT_BY_MODEL = "SORT_BY_MODEL";
export const SELECTED_PAGE_MODEL = "SELECTED_PAGE_MODEL";

export const IS_TOUCHED_MODEL = "IS_TOUCHED_MODEL";

export const SET_SHOW_SIDE_PANEL = "SET_SHOW_SIDE_PANEL";

export const GET_REPTEXT = "GET_REPTEXT";
export const GET_REPTEXT_SUCCESS = "GET_REPTEXT_SUCCESS";
export const GET_REPTEXT_FAILURE = "GET_REPTEXT_FAILURE";

export const CREATE_NEW_REPTEXT = "CREATE_NEW_REPTEXT";
export const CREATE_NEW_REPTEXT_SUCCESS = "CREATE_NEW_REPTEXT_SUCCESS";
export const CREATE_NEW_REPTEXT_FAILURE = "CREATE_NEW_REPTEXT_FAILURE";

export const DELETE_REPTEXT = "DELETE_REPTEXT";
export const DELETE_REPTEXT_SUCCESS = "DELETE_REPTEXT_SUCCESS";
export const DELETE_REPTEXT_FAILURE = "DELETE_REPTEXT_FAILURE";

export const UPDATE_REPTEXT = "UPDATE_REPTEXT";
export const UPDATE_REPTEXT_SUCCESS = "UPDATE_REPTEXT_SUCCESS";
export const UPDATE_REPTEXT_FAILURE = "UPDATE_REPTEXT_FAILURE";

export const GET_REGIONS = "GET_REGIONS";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAILURE = "GET_REGIONS_FAILURE";

// Data Descriptions
export const GET_DDS = "GET_DDS";
export const GET_DDS_SUCCESS = "GET_DDS_SUCCESS";
export const GET_DDS_FAILURE = "GET_DDS_FAILURE";

export const CREATE_NEW_DD = "CREATE_NEW_DD";
export const CREATE_NEW_DD_SUCCESS = "CREATE_NEW_DD_SUCCESS";
export const CREATE_NEW_DD_FAILURE = "CREATE_NEW_DD_FAILURE";

export const UPDATE_DD = "UPDATE_DD";
export const UPDATE_DD_SUCCESS = "UPDATE_DD_SUCCESS";
export const UPDATE_DD_FAILURE = "UPDATE_DD_FAILURE";

export const DELETE_DD = "DELETE_DD";
export const DELETE_DD_SUCCESS = "DELETE_DD_SUCCESS";
export const DELETE_DD_FAILURE = "DELETE_DD_FAILURE";

export const SEARCH_VALUE_DD = "SEARCH_VALUE_DD";
export const SORT_BY_DD = "SORT_BY_DD";
export const SELECTED_PAGE_DD = "SELECTED_PAGE_DD";

export const IS_TOUCHED_DD = "IS_TOUCHED_DD";

export const GET_CONFIG = "GET_CONFIG";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS";
export const GET_CONFIG_FAILURE = "GET_CONFIG_FAILURE";

export const CREATE_NEW_CONFIG = "CREATE_NEW_CONFIG";
export const CREATE_NEW_CONFIG_SUCCESS = "CREATE_NEW_CONFIG_SUCCESS";
export const CREATE_NEW_CONFIG_FAILURE = "CREATE_NEW_CONFIG_FAILURE";

export const CREATE_NEW_DD_VALUE = "CREATE_NEW_DD_VALUE";
export const CREATE_NEW_DD_VALUE_SUCCESS = "CREATE_NEW_DD_VALUE_SUCCESS";
export const CREATE_NEW_DD_VALUE_FAILURE = "CREATE_NEW_DD_VALUE_FAILURE";

export const UPDATE_DD_VALUE = "UPDATE_DD_VALUE";
export const UPDATE_DD_VALUE_SUCCESS = "UPDATE_DD_VALUE_SUCCESS";
export const UPDATE_DD_VALUE_FAILURE = "UPDATE_DD_VALUE_FAILURE";

export const DELETE_DD_VALUE = "DELETE_DD_VALUE";
export const DELETE_DD_VALUE_SUCCESS = "DELETE_DD_VALUE_SUCCESS";
export const DELETE_DD_VALUE_FAILURE = "DELETE_DD_VALUE_FAILURE";

// Views
export const GET_VIEWS = "GET_VIEWS";
export const GET_VIEWS_SUCCESS = "GET_VIEWS_SUCCESS";
export const GET_VIEWS_FAILURE = "GET_VIEWS_FAILURE";

export const CREATE_NEW_VIEW = "CREATE_NEW_VIEW";
export const CREATE_NEW_VIEW_SUCCESS = "CREATE_NEW_VIEW_SUCCESS";
export const CREATE_NEW_VIEW_FAILURE = "CREATE_NEW_VIEW_FAILURE";

export const UPDATE_VIEW = "UPDATE_VIEW";
export const UPDATE_VIEW_SUCCESS = "UPDATE_VIEW_SUCCESS";
export const UPDATE_VIEW_FAILURE = "UPDATE_VIEW_FAILURE";

export const DELETE_VIEW = "DELETE_VIEW";
export const DELETE_VIEW_SUCCESS = "DELETE_VIEW_SUCCESS";
export const DELETE_VIEW_FAILURE = "DELETE_VIEW_FAILURE";

export const SEARCH_VALUE_VIEW = "SEARCH_VALUE_VIEW";
export const SORT_BY_VIEW = "SORT_BY_VIEW";
export const SELECTED_PAGE_VIEW = "SELECTED_PAGE_VIEW";

export const IS_TOUCHED_VIEW = "IS_TOUCHED_VIEW";

// Drawings
export const GET_DRAWINGS = "GET_DRAWINGS";
export const GET_DRAWINGS_SUCCESS = "GET_DRAWINGS_SUCCESS";
export const GET_DRAWINGS_FAILURE = "GET_DRAWINGS_FAILURE";

export const CREATE_NEW_DRAWING = "CREATE_NEW_DRAWING";
export const CREATE_NEW_DRAWING_SUCCESS = "CREATE_NEW_DRAWING_SUCCESS";
export const CREATE_NEW_DRAWING_FAILURE = "CREATE_NEW_DRAWING_FAILURE";

export const UPDATE_DRAWING = "UPDATE_DRAWING";
export const UPDATE_DRAWING_SUCCESS = "UPDATE_DRAWING_SUCCESS";
export const UPDATE_DRAWING_FAILURE = "UPDATE_DRAWING_FAILURE";

export const DELETE_DRAWING = "DELETE_DRAWING";
export const DELETE_DRAWING_SUCCESS = "DELETE_DRAWING_SUCCESS";
export const DELETE_DRAWING_FAILURE = "DELETE_DRAWING_FAILURE";

export const SEARCH_VALUE_DRAWING = "SEARCH_VALUE_DRAWING";
export const SORT_BY_DRAWING = "SORT_BY_DRAWING";
export const SELECTED_PAGE_DRAWING = "SELECTED_PAGE_DRAWING";

export const IS_TOUCHED_DRAWING = "IS_TOUCHED_DRAWING";

// Rules
export const GET_DRAWING_RULES = "GET_DRAWING_RULES";
export const GET_DRAWING_RULES_SUCCESS = "GET_DRAWING_RULES_SUCCESS";
export const GET_DRAWING_LAYER_SUCCESS = "GET_DRAWING_LAYER_SUCCESS";
export const GET_DRAWING_RULES_FAILURE = "GET_DRAWING_RULES_FAILURE";

export const GET_RULES = "GET_RULES";
export const GET_RULES_SUCCESS = "GET_RULES_SUCCESS";
export const GET_RULES_FAILURE = "GET_RULES_FAILURE";

export const DELETE_DRAWING_RULE = "DELETE_DRAWING_RULE";
export const DELETE_DRAWING_RULE_SUCCESS = "DELETE_DRAWING_RULE_SUCCESS";
export const DELETE_DRAWING_RULE_FAILURE = "DELETE_DRAWING_RULE_FAILURE";

export const UPDATE_RULE = "UPDATE_RULE";
export const UPDATE_RULE_SUCCESS = "UPDATE_RULE_SUCCESS";
export const UPDATE_RULE_FAILURE = "UPDATE_RULE_FAILURE";

export const CREATE_RULE = "CREATE_RULE";
export const CREATE_RULE_SUCCESS = "CREATE_RULE_SUCCESS";
export const CREATE_RULE_FAILURE = "CREATE_RULE_FAILURE";

export const NEW_RULE = "NEW_RULE";
export const NEW_RULE_SUCCESS = "NEW_RULE_SUCCESS";
export const NEW_RULE_FAILURE = "NEW_RULE_FAILURE";

export const DELETE_RULE = "DELETE_RULE";
export const DELETE_RULE_SUCCESS = "DELETE_RULE_SUCCESS";
export const DELETE_RULE_FAILURE = "DELETE_RULE_FAILURE";

// Layer
export const GET_LAYER = "GET_LAYER";
export const GET_LAYER_SUCCESS = "GET_LAYER_SUCCESS";
export const GET_LAYER_FAILURE = "GET_LAYER_FAILURE";

// Layer Rule
export const GET_LAYER_RULE = "GET_LAYER_RULE";
export const GET_LAYER_RULE_SUCCESS = "GET_LAYER_RULE_SUCCESS";
export const GET_LAYER_RULE_FAILURE = "GET_LAYER_RULE_FAILURE";

export const CREATE_LAYER_RULE = "CREATE_LAYER_RULE";
export const CREATE_LAYER_RULE_SUCCESS = "CREATE_LAYER_RULE_SUCCESS";
export const CREATE_LAYER_RULE_FAILURE = "CREATE_LAYER_RULE_FAILURE";

export const DELETE_LAYER_RULE = "DELETE_LAYER_RULE";
export const DELETE_LAYER_RULE_SUCCESS = "DELETE_LAYER_RULE_SUCCESS";
export const DELETE_LAYER_RULE_FAILURE = "DELETE_LAYER_RULE_FAILURE";

// Tools
export const GET_TOOLS = "GET_TOOLS";
export const GET_TOOLS_SUCCESS = "GET_TOOLS_SUCCESS";
export const GET_TOOLS_FAILURE = "GET_TOOLS_FAILURE";

export const CREATE_NEW_TOOL = "CREATE_NEW_TOOL";
export const CREATE_NEW_TOOL_SUCCESS = "CREATE_NEW_TOOL_SUCCESS";
export const CREATE_NEW_TOOL_FAILURE = "CREATE_NEW_TOOL_FAILURE";

export const UPDATE_TOOL = "UPDATE_TOOL";
export const UPDATE_TOOL_SUCCESS = "UPDATE_TOOL_SUCCESS";
export const UPDATE_TOOL_FAILURE = "UPDATE_TOOL_FAILURE";

export const DELETE_TOOL = "DELETE_TOOL";
export const DELETE_TOOL_SUCCESS = "DELETE_TOOL_SUCCESS";
export const DELETE_TOOL_FAILURE = "DELETE_TOOL_FAILURE";

// Users
export const GET_U_REGIONS = "GET_U_REGIONS";
export const GET_U_REGIONS_SUCCESS = "GET_U_REGIONS_SUCCESS";
export const GET_U_REGIONS_FAILURE = "GET_U_REGIONS_FAILURE";

export const GET_U_SALESOFFICE = "GET_U_SALESOFFICE";
export const GET_U_SALESOFFICE_SUCCESS = "GET_U_SALESOFFICE_SUCCESS";
export const GET_U_SALESOFFICE_FAILURE = "GET_U_SALESOFFICE_FAILURE";

export const GET_U_ROLES = "GET_U_ROLES";
export const GET_U_ROLES_SUCCESS = "GET_U_ROLES_SUCCESS";
export const GET_U_ROLES_FAILURE = "GET_U_ROLES_FAILURE";

export const GET_USER_MAPPED_REGIONS = "GET_USER_MAPPED_REGIONS";
export const GET_USER_MAPPED_REGIONS_SUCCESS = "GET_USER_MAPPED_REGIONS_SUCCESS";
export const GET_USER_MAPPED_REGIONS_FAILURE = "GET_USER_MAPPED_REGIONS_FAILURE";

export const GET_USER_MAPPED_SALESOFFICE = "GET_USER_MAPPED_SALESOFFICE";
export const GET_USER_MAPPED_SALESOFFICE_SUCCESS = "GET_USER_MAPPED_SALESOFFICE_SUCCESS";
export const GET_USER_MAPPED_SALESOFFICE_FAILURE = "GET_USER_MAPPED_SALESOFFICE_FAILURE";

export const REGION_SELECTION = "REGION_SELECTION";
export const SALES_OFFICE_SELECTION = "SALES_OFFICE_SELECTION";
export const USER_TABLE_DATA_CREATION = "USER_TABLE_DATA_CREATION";

export const ADD_REGION = "ADD_REGION";
export const ADD_REGION_SUCCESS = "ADD_REGION_SUCCESS";
export const ADD_REGION_FAILURE = "ADD_REGION_FAILURE";

export const DELETE_REGION = "DELETE_REGION";
export const DELETE_REGION_SUCCESS = "DELETE_REGION_SUCCESS";
export const DELETE_REGION_FAILURE = "DELETE_REGION_FAILURE";

export const UPDATE_REGION_SALES_MARKET_START = "UPDATE_REGION_SALES_MARKET_START";
export const UPDATE_REGION_SALES_MARKET_SUCCESS = "UPDATE_REGION_SALES_MARKET_SUCCESS";
export const UPDATE_REGION_SALES_MARKET_FAILURE = "UPDATE_REGION_SALES_MARKET_FAILURE";

export const ADD_NEW_MARKET_START = "ADD_NEW_MARKET_START";
export const ADD_NEW_MARKET_SUCCESS = "ADD_NEW_MARKET_SUCCESS";
export const ADD_NEW_MARKET_FAILURE = "ADD_NEW_MARKET_FAILURE";

export const CURRENCY_FETCH_START = "CURRENCY_FETCH_START";
export const CURRENCY_FETCH_SUCCESS = "CURRENCY_FETCH_SUCCESS";
export const CURRENCY_FETCH_FAILURE = "CURRENCY_FETCH_FAILURE";

export const ADD_NEW_SALES_OFFICE_START = "ADD_NEW_SALES_OFFICE_START";
export const ADD_NEW_SALES_OFFICE_SUCCESS = "ADD_NEW_SALES_OFFICE_SUCCESS";
export const ADD_NEW_SALES_OFFICE_FAILURE = "ADD_NEW_SALES_OFFICE_FAILURE";

export const DELETE_SALES_OFFICE_START = "DELETE_SALES_OFFICE_START";
export const DELETE_SALES_OFFICE_SUCCESS = "DELETE_SALES_OFFICE_SUCCESS";
export const DELETE_SALES_OFFICE_FAILURE = "DELETE_SALES_OFFICE_FAILURE";

// Currency

export const GET_CURRENCY = "GET_CURRENCY";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_FAILURE = "GET_CURRENCY_FAILURE";

export const CREATE_NEW_CURRENCY = "CREATE_NEW_CURRENCY";
export const CREATE_NEW_CURRENCY_SUCCESS = "CREATE_NEW_CURRENCY_SUCCESS";
export const CREATE_NEW_CURRENCY_FAILURE = "CREATE_NEW_CURRENCY_FAILURE";

export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
export const UPDATE_CURRENCY_SUCCESS = "UPDATE_CURRENCY_SUCCESS";
export const UPDATE_CURRENCY_FAILURE = "UPDATE_CURRENCY_FAILURE";

export const DELETE_CURRENCY = "DELETE_CURRENCY";
export const DELETE_CURRENCY_SUCCESS = "DELETE_CURRENCY_SUCCESS";
export const DELETE_CURRENCY_FAILURE = "DELETE_CURRENCY_FAILURE";

// Discount

export const GET_DISCOUNTS = "GET_DISCOUNTS";
export const GET_DISCOUNTS_SUCCESS = "GET_DISCOUNTS_SUCCESS";
export const GET_DISCOUNTS_FAILURE = "GET_DISCOUNTS_FAILURE";

export const CREATE_NEW_DISCOUNT = "CREATE_NEW_DISCOUNT";
export const CREATE_NEW_DISCOUNT_SUCCESS = "CREATE_NEW_DISCOUNT_SUCCESS";
export const CREATE_NEW_DISCOUNT_FAILURE = "CREATE_NEW_DISCOUNT_FAILURE";

export const UPDATE_DISCOUNT = "UPDATE_DISCOUNT";
export const UPDATE_DISCOUNT_SUCCESS = "UPDATE_DISCOUNT_SUCCESS";
export const UPDATE_DISCOUNT_FAILURE = "UPDATE_DISCOUNT_FAILURE";

export const DELETE_DISCOUNT = "DELETE_DISCOUNT";
export const DELETE_DISCOUNT_SUCCESS = "DELETE_DISCOUNT_SUCCESS";
export const DELETE_DISCOUNT_FAILURE = "DELETE_DISCOUNT_FAILURE";
export const RENDER_DISCOUNT_LIST_DATA = "RENDER_DISCOUNT_LIST_DATA";

// Transaction Type

export const GET_TRANSACTION_TYPE = "GET_TRANSACTION_TYPE";
export const GET_TRANSACTION_TYPE_SUCCESS = "GET_TRANSACTION_TYPE_SUCCESS";
export const GET_TRANSACTION_TYPE_FAILURE = "GET_TRANSACTION_TYPE_FAILURE";


// region based sales office
export const REGION_BASED_OFFICE_START = "REGION_BASED_OFFICE_START";
export const REGION_BASED_OFFICE_SUCCESS = "REGION_BASED_OFFICE_SUCCESS";
export const REGION_BASED_OFFICE_FAILURE = "REGION_BASED_OFFICE_FAILURE";

export const CREATE_NEW_USER_START = "CREATE_NEW_USER_START";
export const CREATE_NEW_USER_SUCCESS = "CREATE_NEW_USER_SUCCESS";
export const CREATE_NEW_USER_FAILURE = "CREATE_NEW_USER_FAILURE";

export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

// Tools Offered

export const GET_TOOLS_OFFERED = "GET_TOOLS_OFFERED";
export const GET_TOOLS_OFFERED_SUCCESS = "GET_TOOLS_OFFERED_SUCCESS";
export const GET_TOOLS_OFFERED_FAILURE = "GET_TOOLS_OFFERED_FAILURE";

export const CREATE_NEW_TOOL_OFFERED = "CREATE_NEW_TOOL_OFFERED";
export const CREATE_NEW_TOOL_OFFERED_SUCCESS = "CREATE_NEW_TOOL_OFFERED_SUCCESS";
export const CREATE_NEW_TOOL_OFFERED_FAILURE = "CREATE_NEW_TOOL_OFFERED_FAILURE";

export const UPDATE_TOOL_OFFERED = "UPDATE_TOOL_OFFERED";
export const UPDATE_TOOL_OFFERED_SUCCESS = "UPDATE_TOOL_OFFERED_SUCCESS";
export const UPDATE_TOOL_OFFERED_FAILURE = "UPDATE_TOOL_OFFERED_FAILURE";

export const DELETE_TOOL_OFFERED = "DELETE_TOOL_OFFERED";
export const DELETE_TOOL_OFFERED_SUCCESS = "DELETE_TOOL_OFFERED_SUCCESS";
export const DELETE_TOOL_OFFERED_FAILURE = "DELETE_TOOL_OFFERED_FAILURE";

export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const FETCH_USER_ROLE_START = "FETCH_USER_ROLE_START";
export const FETCH_USER_ROLE_SUCCESS = "FETCH_USER_ROLE_SUCCESS";
export const FETCH_USER_ROLE_FAILURE = "FETCH_USER_ROLE_SUCCESS";

export const FETCH_USER_ID_START = "FETCH_USER_ID_START";
export const FETCH_USER_ID_SUCCESS = "FETCH_USER_ID_SUCCESS";
export const FETCH_USER_ID_FAILURE = "FETCH_USER_ID_FAILURE";

// Customers
export const GET_C_CUSTOMERS = "GET_C_CUSTOMERS";
export const GET_C_CUSTOMERS_SUCCESS = "GET_C_CUSTOMERS_SUCCESS";
export const GET_C_CUSTOMERS_FAILURE = "GET_C_CUSTOMERS_FAILURE";

// Markets based on sales office
export const GET_C_SALESOFFICE_MARKETS = "GET_C_SALESOFFICE_MARKETS";
export const GET_C_SALESOFFICE_MARKETS_SUCCESS = "GET_C_SALESOFFICE_MARKETS_SUCCESS";
export const GET_C_SALESOFFICE_MARKETS_FAILURE = "GET_C_SALESOFFICE_MARKETS_FAILURE";

// COMPANY TYPE
export const GET_C_COMPANYTYPE = "GET_C_COMPANYTYPE";
export const GET_C_COMPANYTYPE_SUCCESS = "GET_C_COMPANYTYPE_SUCCESS";
export const GET_C_COMPANYTYPE_FAILURE = "GET_C_COMPANYTYPE_FAILURE";

//{/* expirations dates */}
export const GET_U_EXPIRATIONDATE = "GET_U_EXPIRATIONDATE";
export const GET_U_EXPIRATIONDATE_SUCCESS = "GET_U_EXPIRATIONDATE_SUCCESS";
export const GET_U_EXPIRATIONDATE_FAILURE = "GET_U_EXPIRATIONDATE_FAILURE";

//{/* Status */}
export const GET_C_STATUS = "GET_C_STATUS";
export const GET_C_STATUS_SUCCESS = "GET_C_STATUS_SUCCESS";
export const GET_C_STATUS_FAILURE = "GET_C_STATUS_FAILURE";

export const MARKETS_SELECTION = "MARKETS_SELECTION";
export const EXPIRATION_DATE_SELECTION = "EXPIRATION_DATE_SELECTION";
export const STATUS_SELECTION = "STATUS_SELECTION";

export const CUSTOMER_TABLE_DATA_CREATION = "CUSTOMER_TABLE_DATA_CREATION";

export const CREATE_NEW_CUSTOMER_START = "CREATE_NEW_CUSTOMER_START";
export const CREATE_NEW_CUSTOMER_SUCCESS = "CREATE_NEW_CUSTOMER_SUCCESS";
export const CREATE_NEW_CUSTOMER_FAILURE = "CREATE_NEW_CUSTOMER_FAILURE";

export const UPDATE_CUSTOMER_START = "UPDATE_CUSTOMER_START";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILURE = "UPDATE_CUSTOMER_FAILURE";


export const DELETE_CUSTOMERS_START = "DELETE_CUSTOMERS_START";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAILURE = "DELETE_CUSTOMER_FAILURE";

//For License data
export const GET_C_LICENSE = "GET_C_LICENSE";
export const GET_C_LICENSE_SUCCESS = "GET_C_LICENSE_SUCCESS";
export const GET_C_LICENSE_FAILURE = "GET_C_LICENSE_FAILURE";

//For transaction data
export const GET_C_TRANSACTION = "GET_C_TRANSACTION";
export const GET_C_TRANSACTION_SUCCESS = "GET_C_TRANSACTION_SUCCESS";
export const GET_C_TRANSACTION_FAILURE = "GET_C_TRANSACTION_FAILURE";

//For Report data
export const GET_REPORT_FETCH_STARTED = "GET_REPORT_FETCH_STARTED";
export const GET_REPORT_FETCH_SUCCESS = "GET_REPORT_FETCH_SUCCESS";
export const GET_REPORT_FETCH_FAILURE = "GET_REPORT_FETCH_FAILURE"

//For Editing sales office
export const UPDATE_SALES_OFFICE_STARTED = "UPDATE_SALES_OFFICE_STARTED";
export const UPDATE_SALES_OFFICE_SUCCESS = "UPDATE_SALES_OFFICE_SUCCESS";
export const UPDATE_SALES_OFFICE_FAILURE = "UPDATE_SALES_OFFICE_FAILURE";

// Generate License
export const CREATE_NEW_GENERATELICENSE_START = "CREATE_NEW_GENERATELICENSE_START";
export const CREATE_NEW_GENERATELICENSE_SUCCESS = "CREATE_NEW_GENERATELICENSE_SUCCESS";
export const CREATE_NEW_GENERATELICENSE_FAILURE = "CREATE_NEW_GENERATELICENSE_FAILURE";

// Create License
export const GET_CREATE_LICENSEKEY = "GET_CREATE_LICENSEKEY";
export const GET_CREATE_LICENSEKEY_SUCCESS = "GET_CREATE_LICENSEKEY_SUCCESS";
export const GET_CREATE_LICENSEKEY_FAILURE = "GET_CREATE_LICENSEKEY_FAILURE";

// Discounts Offered
export const GET_DISCOUNT_OFFERED = "GET_DISCOUNT_OFFERED";
export const GET_DISCOUNT_OFFERED_SUCCESS = "GET_DISCOUNT_OFFERED_SUCCESS";
export const GET_DISCOUNT_OFFERED_FAILURE = "GET_DISCOUNT_OFFERED_FAILURE";

export const CREATE_DISCOUNT_OFFERED = "CREATE_DISCOUNT_OFFERED";
export const CREATE_DISCOUNT_OFFERED_SUCCESS = "CREATE_DISCOUNT_OFFERED_SUCCESS";
export const CREATE_DISCOUNT_OFFERED_FAILURE = "CREATE_DISCOUNT_OFFERED_FAILURE";

export const UPDATE_DISCOUNT_OFFERED = "UPDATE_DISCOUNT_OFFERED";
export const UPDATE_DISCOUNT_OFFERED_SUCCESS = "UPDATE_DISCOUNT_OFFERED_SUCCESS";
export const UPDATE_DISCOUNT_OFFERED_FAILURE = "UPDATE_DISCOUNT_OFFERED_FAILURE";

//bredcrumb setting constants
export const SETTING_BREDCRUMB = "SETTING_BREDCRUMB";
// Update Quantity
export const UPDATE_QUANTITY_START = "UPDATE_QUANTITY_START";
export const UPDATE_QUANTITY_SUCCESS = "UPDATE_QUANTITY_SUCCESS";
export const UPDATE_QUANTITY_FAILURE = "UPDATE_QUANTITY_FAILURE";

// Renewal License
export const RENEWAL_LICENSE_START = "RENEWAL_LICENSE_START";
export const RENEWAL_LICENSE_SUCCESS = "RENEWAL_LICENSE_SUCCESS";
export const RENEWAL_LICENSE_FAILURE = "RENEWAL_LICENSE_FAILURE";

// Customers Contact
export const GET_CUSTOMER_CONTACTS = "GET_CUSTOMER_CONTACTS";
export const GET_CUSTOMER_CONTACTS_SUCCESS = "GET_CUSTOMER_CONTACTS_SUCCESS";
export const GET_CUSTOMER_CONTACTS_FAILURE = "GET_CUSTOMER_CONTACTS_FAILURE";

// Create Contact
export const CREATE_NEW_CONTACT = "CREATE_NEW_CONTACT";
export const CREATE_NEW_CONTACT_SUCCESS = "CREATE_NEW_CONTACT_SUCCESS";
export const CREATE_NEW_CONTACT_FAILURE = "CREATE_NEW_CONTACT_FAILURE";

// Delete Customer Contact
export const DELETE_CUSTOMERCONTACT_START = "DELETE_CUSTOMERCONTACT_START";
export const DELETE_CUSTOMERCONTACT_SUCCESS = "DELETE_CUSTOMERCONTACT_SUCCESS";
export const DELETE_CUSTOMERCONTACT_FAILURE = "DELETE_CUSTOMERCONTACT_FAILURE";

// Update Contact
export const UPDATE_CUSTOMER_CONTACT = "UPDATE_CUSTOMER_CONTACT";
export const UPDATE_CUSTOMER_CONTACT_SUCCESS = "UPDATE_CUSTOMER_CONTACT_SUCCESS";
export const UPDATE_CUSTOMER_CONTACT_FAILURE = "UPDATE_CUSTOMER_CONTACT_FAILURE";

export const RENDER_DISCOUNT_OFFERED_LIST_DATA = "RENDER_DISCOUNT_OFFERED_LIST_DATA";

export const GET_BY_USER_MAPPED_REGIONS = "GET_BY_USER_MAPPED_REGIONS";
export const GET_BY_USER_MAPPED_REGIONS_SUCCESS = "GET_BY_USER_MAPPED_REGIONS_SUCCESS";
export const GET_BY_USER_MAPPED_REGIONS_FAILURE = "GET_BY_USER_MAPPED_REGIONS_FAILURE";